/*** IMPORTS FROM imports-loader ***/
(function() {
var mp = window.mp;
var exports = undefined;
var define = undefined;
var module = undefined;

/* eslint camelcase: 0, eqeqeq: 0, no-var: 0 */
/* globals _, JSWidget */

var Badge = function(div, options, callback) {
  this.class_name = `badge_container`;
  this.default_options = {
    from: `partner`,
    switcher: true,
  };
  this.create(div, options, callback);
};
_.inherit(Badge, JSWidget);

Badge.prototype.create = function(div, options, callback) {
  Badge.superclass.create.call(this, div);
  this.callback = callback || function() {};

  this.options = _.extend(this.default_options, options);
  this.url = `http://mixpanel.com/f/` + this.options.from;

  this.root_path = `/site_media/images/partner`;
  this.blue = this.root_path + `/badge_blue.png`;
  this.light = this.root_path + `/badge_light.png`;

  this.blue_text = `Get blue version`;
  this.light_text = `Get light version`;
  this.type = 0;

  this.img = $(`<img>`);
  this.toggle = $(`<div>`).addClass(`toggle`);

  this.container.append(this.img);
  if (this.options.switcher) {
    this.container.append(this.toggle);
  }

  this.set_type(this.type);
  this.bindings();

  return this;
};

Badge.prototype.get_html = function(img_src) {
  return [`<a href="`, this.url, `">`,
    `<img src="http://mixpanel.com`, img_src, `" alt="Mobile Analytics" />`,
    `</a>`].join(``);
};

// 0 for blue, 1 for light
Badge.prototype.set_type = function(type) {
  this.type = type;
  if (this.type == 0) {
    this.img.attr(`src`, this.blue);
    this.toggle.text(this.light_text);
    this.callback(this.blue, this.get_html(this.blue));
  } else if (this.type == 1) {
    this.img.attr(`src`, this.light);
    this.toggle.text(this.blue_text);
    this.callback(this.light, this.get_html(this.light));
  }
};

Badge.prototype.bindings = function() {
  var that = this;
  this.toggle.click(function() {
    that.type = (that.type == 0) ? 1 : 0;
    that.set_type(that.type);
  });
};

Badge.prototype.styles = function() {
  return {
    '': {
      'display': `inline-block`,
      'position': `relative`,
    },
    '.toggle': {
      'font-size': `9px`,
      'color': `#41658C`,
      'cursor': `pointer`,
      'margin-left': `8px`,
    },
  };
};

}.call(window));